import dayjs from "dayjs";
import { DataTable } from "@/components/tables";
import DeleteWithConfirm from "./DeleteWithConfirm";
import { Ownership } from "./UserGroupDetails.types";

interface OwnershipFlatTableProps {
  items: Ownership[];
  getUserName: (userId: string) => string;
  canManageOwnership: boolean;
  groupId?: string;
  refetch: () => void;
}

const OwnershipFlatTable = ({
  items,
  getUserName,
  canManageOwnership,
  groupId,
  refetch,
}: OwnershipFlatTableProps) => (
  <DataTable<Ownership>
    data={{ items }}
    header={[
      {
        id: 0,
        uid: "rule",
        label: "Rule",
        render: item => <div>{item.ruleOperator || ""}</div>,
      },
      {
        id: 1,
        uid: "entity_type",
        label: "Entity Type",
        render: item => <div>{item.entity_type}</div>,
      },
      {
        id: 2,
        uid: "condition_key",
        label: "Condition Key",
        render: item => <div>{item.ownership_rule.condition_key}</div>,
      },
      {
        id: 3,
        uid: "condition_type",
        label: "Condition Type",
        render: item => <div>{item.ownership_rule.condition_type}</div>,
      },
      {
        id: 4,
        uid: "condition_value",
        label: "Condition Value",
        render: item => (
          <div className="al-break-words">
            {item.ownership_rule.condition_key === "tag" && item.ownership_rule.condition_key_value
              ? `${item.ownership_rule.condition_key_value}: ${item.ownership_rule.condition_value}`
              : item.ownership_rule.condition_value}
          </div>
        ),
      },
      {
        id: 5,
        uid: "created",
        label: "Created",
        render: item => (
          <div>
            <div>
              <b>{getUserName(item.created_by)}</b>
            </div>
            <div>{dayjs(item.created_at).format("DD MMM YYYY hh:mm")}</div>
          </div>
        ),
      },
      {
        id: 6,
        uid: "updated",
        label: "Updated",
        render: item => (
          <div>
            <div>
              <b>{getUserName(item.updated_by)}</b>
            </div>
            <div>{dayjs(item.updated_at).format("DD MMM YYYY hh:mm")}</div>
          </div>
        ),
      },
      {
        id: 7,
        uid: "actions",
        label: "Actions",
        render: item => (
          <div>
            {canManageOwnership ? (
              <DeleteWithConfirm
                entityId={item.id}
                id={groupId || ""}
                refetch={refetch}
                entityType="ownership"
                title={`Delete ownership ${item.ownership_rule.condition_value}`}
              />
            ) : null}
          </div>
        ),
      },
    ]}
  />
);

export default OwnershipFlatTable;
